import baseColors from '@shop/styleguide/dist/js/colors/bitiba-colors';

const colors = {
  primary: {
    light: baseColors.primaryLight,
    base: baseColors.primaryMid,
    dark: baseColors.primaryDark,
    gradient: baseColors.primaryGradient
  },
  secondary: {
    light: baseColors.secondaryLight,
    base: baseColors.secondaryMid,
    dark: baseColors.secondaryDark,
    gradient: baseColors.secondaryGradient
  },
  tertiary: {
    light: baseColors.greyLight,
    base: baseColors.greyMid,
    dark: baseColors.greyDark
  },
  greyscale: {
    white: baseColors.white,
    subtle: baseColors.greyUltralight,
    light: baseColors.greyLight,
    base: baseColors.greyMid,
    dark: baseColors.greyMid,
    darker: baseColors.greyDark,
    black: baseColors.greyDark
  },
  accents: {
    info: baseColors.infoMid,
    success: baseColors.successMid,
    error: baseColors.warningMid
  },
  others: {
    middleBar: '#ffda00',
    lowerBar: baseColors.secondaryMid,
    lowerBarGradient: baseColors.secondaryGradient,
    lowerBarGradientLeftColor: baseColors.secondaryDark,
    lowerBarGradientRightColor: baseColors.secondaryMid,
    lowerBarLinksHoverBackground: baseColors.primaryMid
  }
};

const typography = {
  fontSize: {
    fs1: '10px',
    fs2: '12px',
    fs3: '14px',
    fs4: '16px',
    fs5: '18px',
    fs6: '20px',
    fs7: '22px',
    fs8: '24px',
    fs9: '28px',
    fs10: '32px',
    base: '14px'
  },
  lineHeight: {
    lh1: '14px',
    lh2: '16px',
    lh3: '18px',
    lh4: '20px',
    lh5: '22px',
    lh6: '24px',
    lh7: '26px',
    lh8: '29px',
    lh9: '36px',
    lh10: '38px',
    base: '1.45'
  },
  iconSize: {
    is1: '16px',
    is2: '18px',
    is3: '20px',
    is4: '24px',
    is5: '28px',
    is6: '32px',
    is7: '36px',
    is8: '40px',
    is9: '43px',
    is10: '50px',
    is11: '57px',
    is12: '64px',
    is13: '72px',
    base: '24px'
  },
  fontFamilies: {
    ff1: 'Arial,sans-serif'
  }
};

export default {
  colors,
  typography
}
